if (!customElements.get('dots-accordion')) {
  customElements.define(
    'dots-accordion',
    class DotsAccordion extends HTMLElement {
      constructor() {
        super();
        this.activeIndex = -1;
      }

      connectedCallback() {
        this.buttons = Array.from(
          this.querySelectorAll('.dot-container button')
        );
        this.detailsElements = Array.from(
          this.querySelectorAll('.dots-accordion details')
        );
        this.dotsContainer = this.querySelector('.dots-container');

        const initialActiveButton = this.buttons.find((button) =>
          button.classList.contains('active')
        );
        if (initialActiveButton) {
          this.activeIndex = this.buttons.indexOf(initialActiveButton);
        }

        this.attachEventListeners();
      }

      attachEventListeners() {
        // Handle button clicks
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => {
            this.toggleAccordion(index);
          });
        });

        // Handle manual details toggle (keyboard/accessibility)
        this.detailsElements.forEach((details, index) => {
          details.addEventListener('toggle', (e) => {
            this.syncButtonState(index, e.newState === 'open');
          });
        });
      }

      toggleAccordion(index) {
        const isCurrentlyActive = this.activeIndex === index;

        if (isCurrentlyActive) {
          this.closeAccordion(index);
        } else {
          this.openAccordion(index);
        }
      }

      openAccordion(index) {
        this.detailsElements[index].open = true;
      }

      closeAccordion(index) {
        this.detailsElements[index].open = false;
      }

      activateButton(index) {
        const button = this.buttons[index];
        button.classList.add('active');
        button.setAttribute('aria-label', `${button.dataset.label} gizle`);
        button.setAttribute('aria-expanded', 'true');
      }

      deactivateButton(index) {
        const button = this.buttons[index];
        button.classList.remove('active');
        button.setAttribute('aria-label', `${button.dataset.label} göster`);
        button.setAttribute('aria-expanded', 'false');
      }

      syncButtonState(index, isOpen) {
        if (isOpen) {
          this.activateButton(index);
          this.activeIndex = index;
        } else {
          this.deactivateButton(index);
          if (index === this.activeIndex) {
            this.activeIndex = -1;
          }
        }
      }
    }
  );
}
